import { Outlet, useLocation } from 'react-router-dom'
import { Stack, Typography } from '@mui/material'
import { FormBlock } from '../../../../common/FormGenerator'
import { getFormConfig } from '../../../../components/ProjectsPage/ProjectsFiltration/settingsConfig'
import { FormProvider, useForm } from 'react-hook-form'
import { ProjectsFiltration } from '../../../../components/ProjectsPage/ProjectsFiltration'
import { PageLayout } from '../../../../components/PageLayout'
import { ProjectsTabs } from '../../../../components/ProjectsPage/ProjectsTabs'
import { useGetProjectsStatsQuery } from '../../../../api/projects'
import { useLayoutEffect, useMemo } from 'react'

const normalizeStringValue = (value: string | null): string => value?.trim() ?? ''

export const ProjectsLayout = () => {
  useLayoutEffect(() => {
    document.title = 'Проекты'
  }, [])

  const { search } = useLocation()
  const defaultValues = useMemo(() => {
    const searchParams = new URLSearchParams(search)

    return {
      search: normalizeStringValue(searchParams.get('query')),
      typeProject: normalizeStringValue(searchParams.get('type')) || 'all',
      stage: normalizeStringValue(searchParams.get('stage')) || 'all',
    }
  }, [search])

  const methods = useForm({ mode: 'all', defaultValues })

  const { data: projectsStats, isLoading: isStatsLoading, isError: isStatsError } = useGetProjectsStatsQuery()

  const publishedCount = projectsStats?.projects_published_count ?? 0
  const unpublishedCount = projectsStats?.projects_unpublished_count ?? 0
  const totalCount = projectsStats?.projects_total_count ?? publishedCount + unpublishedCount

  const statsTextSx = { fontSize: 12, lineHeight: 1.4, textTransform: 'none' as const }

  const statsAside = !isStatsLoading && !isStatsError ? (
    <Stack direction="row" spacing={1.5} flexWrap="wrap" alignItems="baseline">
      <Typography component="span" variant="body2" color="text.secondary" sx={statsTextSx}>
        Опубликовано: {publishedCount}
      </Typography>
      <Typography component="span" variant="body2" color="text.secondary" sx={statsTextSx}>
        Не опубликовано: {unpublishedCount}
      </Typography>
      <Typography component="span" variant="body2" color="text.secondary" sx={statsTextSx}>
        Всего: {totalCount}
      </Typography>
    </Stack>
  ) : null

  return (
    <FormProvider {...methods}>
      <PageLayout
        title="Проекты"
        titleAside={statsAside}
        mainComponent={<Outlet />}
        sideComponent={<ProjectsFiltration />}
        searchComponent={<FormBlock formFieldConfig={getFormConfig('search')} />}
        topComponent={<ProjectsTabs />}
      />
    </FormProvider>
  )
}
